import { Radio, ExternalLink, Trophy } from "lucide-react";

const BTN = "inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 px-5 py-3 text-sm font-bold uppercase tracking-widest text-black hover:bg-amber-400 transition-colors text-center";

const ExtButton = ({ href, children, testid }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={BTN}>
    <ExternalLink className="w-4 h-4 shrink-0" /> {children}
  </a>
);

const Card = ({ icon: Icon, title, text, testid, children }) => (
  <section data-testid={testid} className="py-6">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="rounded-2xl border border-amber-500/30 bg-[#14161A] p-5 sm:p-6 overflow-hidden">
        <h2 className="flex items-center gap-2 font-display text-2xl sm:text-3xl font-black uppercase text-white">
          <Icon className="w-6 h-6 text-amber-500 shrink-0" /> {title}
        </h2>
        <p className="mt-2 text-sm text-white/70">{text}</p>
        {children}
      </div>
    </div>
  </section>
);

export const RadioPlayer = () => (
  <>
    <Card icon={Radio} title="Lyssna på Enduroradio live" text="Lyssna på Enduroradio live under tävlingen." testid="enduroradio-section">
      <div className="mt-5 flex flex-col sm:flex-row flex-wrap gap-3">
        <ExtButton href="https://www.internet-radio.com/station/enduroradio/" testid="radio-internet-radio-btn">Lyssna på internet-radio.com</ExtButton>
        <ExtButton href="https://www.nts-timing.se/radio" testid="radio-nts-btn">Lyssna på NTS-Timing webbradio</ExtButton>
      </div>
    </Card>
    <Card icon={Trophy} title="Live-resultat" text="Följ resultaten live från NTS-Timing." testid="live-results-section">
      <iframe
        src="https://live.ntslive.se/"
        title="Live-resultat NTS-Timing"
        loading="lazy"
        data-testid="live-results-iframe"
        className="mt-5 block w-full max-w-full h-[600px] md:h-[800px] rounded-xl border-0 bg-white"
      />
      <div className="mt-5 flex flex-col sm:flex-row flex-wrap gap-3">
        <ExtButton href="https://live.ntslive.se/" testid="live-results-open-btn">Öppna live-resultat i nytt fönster</ExtButton>
        <ExtButton href="http://ntslive.se/" testid="live-results-all-btn">Alla resultat på ntslive.se</ExtButton>
      </div>
    </Card>
  </>
);
